module.exports = __webpack_public_path__ + "static/SharpSansNo1-Bold-825d42527e9b41fb9976164c8cd8c5e8.woff2";